// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.scrollable-requester-list[data-v-e9ee6fb8] {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
